import { ChangeDetectionStrategy, Component } from '@angular/core';
// eslint-disable-next-line @tseslint/no-unused-vars
import { OverviewHeaderComponent } from '../../overview-header.component';

/**
 * Add this Component to {@link OverviewHeaderComponent | app-overview-header} to add additions to the header in a dedicated spot
 * @example
 *
 * ```html
 * <app-overview-header>
 *   <!-- other overview-header child-components... -->
 *   <app-overview-header-additional-options>
 *    <!-- for example: -->
 *    <button>My Extra Button</button>
 *   </app-overview-header-additional-options>
 *   <!-- other overview-header child-components... -->
 * </app-overview-header>
 * ```
 */
@Component({
  selector: 'app-overview-header-additional-options',
  standalone: true,
  imports: [],
  templateUrl: './overview-header-additional-options.component.html',
  styleUrl: './overview-header-additional-options.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class OverviewHeaderAdditionalOptionsComponent {}
